import React, { useState } from 'react'
import AsyncSelect from 'react-select/async'
import { StylesConfig } from 'react-select'

import loadProducts, { Product, ProductVariant } from '../lib/loadProducts'
import { getProductName } from '../common/services/getProductName'

const createOptionForProduct = (product: Product): Option => {
    return { value: product.id, label: getProductName(product.id).toString() }
}

const loadOptions = (productVariant: ProductVariant) =>
    loadProducts(productVariant && { productVariant }).then((products) =>
        products.map((product) => createOptionForProduct(product)).sort((o1, o2) => o1.label.localeCompare(o2.label))
    )

const addEmptyOption = (options: Option[], emptyOption?: boolean | string) => {
    if (!emptyOption) options
    const defaultOption: Option = { value: undefined, label: typeof emptyOption === 'string' ? emptyOption : 'None' }
    return [defaultOption].concat(options)
}

const customStyles: StylesConfig = {
    control: (base) => ({
        ...base,
        height: 34,
        minHeight: 34,
        fontSize: 14,
    }),
}

const ProductSelect: React.FC<Props> = ({ value, emptyOption, onChange }) => {
    const [storedOptions, storeOptions] = useState<Option[]>([])

    const requestOptions = () => {
        storeOptions([])
        return loadOptions(ProductVariant.MeasurementDevice).then((options) => {
            const newOptions = addEmptyOption(options, emptyOption)
            storeOptions(newOptions)
            return newOptions
        })
    }

    return (
        <AsyncSelect
            cacheOptions
            defaultOptions
            value={storedOptions.find((option) => option.value === value)}
            loadOptions={requestOptions}
            isSearchable={false}
            onChange={(product) => {
                if (onChange) onChange(product?.value)
            }}
            styles={customStyles}
        />
    )
}

export default ProductSelect

export type Option = {
    value?: number
    label: string
}

export type Props = {
    value?: number
    emptyOption?: string
    onChange?: (productTypeId?: number) => void
}
